import type { RiskLevel, SiteAnalysisResponse } from '@/lib/api.types';
import type { StatusKind } from '@/components/ui/StatusRow/StatusRow';
import {
  overallRank,
  rankToStatus,
  rankToStatusLabel,
  riskDimensions,
  type RiskDimension,
} from '@/lib/risk';

// 単一の「結論」生成器。レポート先頭の VerdictCard と、地図横の SiteBrief(ready) ミニ結論が
// 同じ判定・同じ文言になるよう、両者はここだけを呼ぶ。ロジックを二重に持つと結論が食い違い、
// 購入者の信頼を損なうため、buildVerdict を唯一の真実とする。
export type Verdict = {
  overall: RiskLevel;
  status: StatusKind;
  /** 総合バッジの文言（◯該当なし / △要確認…）。データ不足時は「判定中」。 */
  statusLabel: string;
  /** 一文サマリ。要確認の観点名を畳み込む。 */
  message: string;
  dims: RiskDimension[];
};

export const STATUS_SYMBOL: Record<StatusKind, string> = {
  safe: '◯',
  alert: '△',
  neutral: '…',
};

export function buildVerdict(analysis: SiteAnalysisResponse): Verdict {
  const overall = overallRank(analysis);
  const status = rankToStatus(overall);
  const dims = riskDimensions(analysis);
  const alerts = dims.filter((d) => rankToStatus(d.rank) === 'alert');

  let message: string;
  if (status === 'alert') {
    message = `${alerts.map((d) => d.label).join('・')}に、気にとめておきたい点があります。`;
  } else if (status === 'safe') {
    message = '大きな注意点は見つかりませんでした。各章で詳しくご確認ください。';
  } else {
    message = '判定に必要なデータが十分にそろいませんでした。各章をご確認ください。';
  }

  return {
    overall,
    status,
    statusLabel: rankToStatusLabel(overall, '判定中'),
    message,
    dims,
  };
}
